(function () {
  const STYLE_ID = 'fairy-style';
  const STYLE_CSS = `
    button.activator .activator__icon {
      display: none !important;
    }
    button.activator .activator__label {
      font-size: 0 !important;
    }
    button.activator .activator__label::after {
      content: 'Ask a Fairy' !important;
      font-size: 14px !important;
      font-family: 'JP_Millie_June', sans-serif !important;
    }
    button.activator {
      display: flex !important;
      align-items: center !important;
      gap: 8px !important;
    }
    button.activator::before {
      content: '' !important;
      display: block !important;
      width: 50px !important;
      height: 50px !important;
      background-image: url('https://cdn.shopify.com/s/files/1/0667/9389/8229/files/KIDS_LABELS_INSTAGRAM_POSTS.png?v=1762036914') !important;
      background-size: cover !important;
      background-position: center !important;
      flex-shrink: 0 !important;
      order: -1 !important;
    }
  `;

  function injectStyleInto(root) {
    if (!root || root.querySelector('#' + STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = STYLE_CSS;
    root.appendChild(style);
  }

  function revealChat() {
    const chat = document.querySelector('shopify-chat');
    if (chat) chat.classList.add('fairy-ready');
  }

  const originalAttachShadow = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function (init) {
    const root = originalAttachShadow.call(this, init);

    if (this.tagName === 'SHOPIFY-CHAT' || this.tagName === 'SHOPIFY-AGENT-RUNTIME') {
      injectStyleInto(root);

      const obs = new MutationObserver(() => {
        if (root.lastElementChild?.id !== STYLE_ID) {
          injectStyleInto(root);
          const style = root.querySelector('#' + STYLE_ID);
          if (style && root.lastElementChild !== style) root.appendChild(style);
        }
      });
      obs.observe(root, { childList: true, subtree: true });

      
      if (this.tagName === 'SHOPIFY-CHAT') {
        revealChat();
      }
    }

    return root;
  };

  
  document.addEventListener('DOMContentLoaded', function () {
    const chat = document.querySelector('shopify-chat');
    if (chat && chat.shadowRoot) {
      injectStyleInto(chat.shadowRoot);
    }
    revealChat();
  });

  
  setTimeout(revealChat, 1000);
})();